// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";

import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPost } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableSimple } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import { isRequired, useForm } from "../../../components/isRequired";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import "react-toastify/dist/ReactToastify.css";
import { BiArrowBack } from "react-icons/bi";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getObjectIdsByPRListID } from "../../../components/tools/PCGetter";

const ApprovalPurchaseOrderPage = ({}) => {
  let initialState = {
    DatePR: new Date(),
  };

  let initialStateModal = {
    SDTDate: new Date(),
  };
  const validations = [
    ({ UserPCName }) =>
      isRequired(UserPCName) || { UserPCName: "Nama UserPC wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Status wajib diisi" },
    ({ KelompokID }) =>
      isRequired(KelompokID) || { KelompokID: "Kelompok wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Kelompok wajib diisi" },
    ({ DetailAccountID }) =>
      isRequired(DetailAccountID) || {
        DetailAccountID: "Detail Account wajib diisi",
      },
    ({ Status }) =>
      isRequired(Status) || { Status: "Detail Account wajib diisi" },
  ];

  const {
    changed,
    values,
    isValid,
    touched,
    submitHandler,
    customHandler,
    changeHandler,
    errors,
    blastChange,
    changeHandlerTermin,
  } = useForm(initialState, validations);

  const barang = useMutation((formData) => fetchGet("Master/Barang/min"));
  const [buttonTouched, setButtonTouched] = useState(false);
  const [detail, setDetail] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [modalDetail, setModalDetail] = useState(initialStateModal);
  const [modalID, setModalID] = useState(0);
  const [pRListComparison, setPRListComparison] = useState(0);
  const [isJasa, setisJasa] = useState(false);
  const [sTermin1, setsTermin1] = useState(0);
  const [sTermin2, setsTermin2] = useState(0);
  const [sTermin3, setsTermin3] = useState(0);
  const [PriceComparisonFromPRID, setPriceComparisonFromPRID] = useState({});
  const ModalOpener = (detail) => {
    setShowModal(true);
  };
  const param = useLocation();

  const priceComparison = useMutation((formData) =>
    fetchGet("Procurement/PriceComparisonFromPRID/" + formData)
  );

  const mutationAdd = useMutation((formData) =>
    fetchPost("Procurement/PurchaseRequisition", formData)
  );
  const mutationGet = useMutation((formData) =>
    fetchGet("Procurement/PurchaseRequisition/" + formData)
  );
  const mutationUpdate = useMutation((formData) =>
    fetchPost("Procurement/PurchaseOrder/approval", formData)
  );
  const ModalEdit = (detail, id) => {
    setModalID(id);
    setModalDetail(detail);
    setShowModal(true);
    setShowModalEdit(true);
  };

  const ModalDelete = (id) => {
    let newDetail = [...detail];
    newDetail.splice(id, 1);
    setDetail(newDetail);
  };

  const customHandlerTermin = (e) => {
    customHandler(e);
    console.log(values);
    if (e == "Termin1") {
      setsTermin1(1);
      setsTermin2(0);
      setsTermin3(0);
    }
  };

  const navigate = useNavigate();

  useEffect(() => {
    // console.log(priceComparison);
  }, []);

  useEffect(() => {
    barang.mutate();
    if (param.state) {
      priceComparison.mutate(param.state.PurchaseRequisitionID);
      mutationGet.mutate(param.state.PurchaseRequisitionID);
    }
  }, []);

  useEffect(() => {
    if (priceComparison.data) {
      setPriceComparisonFromPRID(priceComparison);
    }
  }, [priceComparison.status]);

  useEffect(() => {
    if (mutationUpdate) {
      if (mutationUpdate.isSuccess) {
        navigate("/approval-list");
      }
    }
  }, [mutationUpdate.status]);

  useEffect(() => {
    if (mutationGet.data) {
      const data = mutationGet.data.data;
      setDetail(data.PRList);
      blastChange(data);
      setisJasa(data.Tipe == "Jasa" ? true : false);
      setsTermin1(data.statusTermin1);
      setsTermin2(data.statusTermin2);
      setsTermin3(data.statusTermin3);
    }
  }, [mutationGet.status]);


  let user = JSON.parse(localStorage.getItem("user"));

  const getDataFromURL = (url) =>
    new Promise((resolve, reject) => {
      url = url.replaceAll("/", "-");
      setTimeout(() => {
        fetch(process.env.REACT_APP_API_UPLOAD_URL + "file/" + url, {
          method: "GET", // or 'PUT'
        })
          .then((response) => response.blob())
          .then((data) => {
            const file = window.URL.createObjectURL(data);
            window.open(file);
          })
          .catch((err) => {
            toast.warning("Data not Found!", {
              position: "top-center",
              autoClose: 1000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              theme: "light",
            });
          });
      });
    }, 2000);
  const header = [
    { name: "Barang", key: "BarangID", modifiers: "Barang" },
    { name: "Satuan", key: "BarangID", modifiers: "BarangSatuan" },
    { name: "Stock", key: "Stock", modifiers: "number" },
    { name: "Jumlah Pengajuan", key: "Qty", modifiers: "number" },
    { name: "Tanggal dibutuhkan", key: "SDTDate", modifiers: "dateOnly" },
    { name: "Spesifikasi", key: "Specification", modifiers: "Text" },
  ];

  const Kirim = (type) => {
    const anyTerminDefined =
      parseFloat(values.Termin1 || 0) > 0 ||
      parseFloat(values.Termin2 || 0) > 0 ||
      parseFloat(values.Termin3 || 0) > 0;
    if (type === "1" && isJasa && anyTerminDefined) {
      const hasTermin =
        values.CheckStatusTermin1 ||
        values.CheckStatusTermin2 ||
        values.CheckStatusTermin3;
      if (!hasTermin) {
        toast.error("Pilih minimal satu termin sebelum approve!", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          theme: "light",
        });
        return;
      }
    }
    mutationUpdate.mutate({
      PurchaseRequisitionID: param.state.PurchaseRequisitionID,
      Approved: type,
      Values: values,
    });
  };

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            {/* {pRListComparison} */}
            <Card>
              <div className="flex flex-col  mt-5">
                <div className="flex w-full justify-end flex-col sm:flex-row ">
                  <button
                    onClick={() => navigate("/approval-list")}
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    <BiArrowBack className="text-xl text-gray-800 pr-2" />
                    Kembali
                  </button>
                  <button
                    onClick={() => Kirim("1")}
                    className="bg-green-100 flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    {mutationAdd.isLoading ? (
                      <>
                        <svg
                          aria-hidden="true"
                          role="status"
                          className="inline mr-3 w-4 h-4 text-white animate-spin"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#E5E7EB"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="current
                                       Color"
                          />
                        </svg>
                        Loading
                      </>
                    ) : (
                      "Approve"
                    )}
                  </button>
                  <button
                    onClick={() => Kirim("2")}
                    className="bg-red-400 flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    {mutationAdd.isLoading ? (
                      <>
                        <svg
                          aria-hidden="true"
                          role="status"
                          className="inline mr-3 w-4 h-4 text-white animate-spin"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#E5E7EB"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="current
                                       Color"
                          />
                        </svg>
                        Loading
                      </>
                    ) : (
                      "Tolak"
                    )}
                  </button>
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"Bagian"}
                    value={values}
                    name={"BagianID"}
                    title={"Bagian"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"dateLock"}
                    value={values}
                    name={"DatePR"}
                    title={"Tanggal MSR"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"TipePR"}
                    value={values}
                    name={"Tipe"}
                    title={"Tipe"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                {/* {isJasa ? (
                  <div className="w-1/3">
                    <HrdInputGenerator
                      type={"Termin1"}
                      value={values}
                      name={"JenisTermin"}
                      title={"Pilih Termin"}
                      onChange={changeHandlerTermin}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={false}
                      errors={errors}
                      disabled={true}
                      priceComparison={PriceComparisonFromPRID}
                      isApproval={values.Termin1 <= 0 ? false : true}
                      checked={sTermin1 <= 0 ? false : true}
                      showNominal={true}
                    />
                  </div>
                ) : null}
                {isJasa ? (
                  <div className="w-1/3">
                    <HrdInputGenerator
                      type={"text"}
                      value={values}
                      name={"NominalTermin"}
                      title={"Nominal Termin"}
                      onChange={customHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={false}
                      errors={errors}
                      disabled={true}
                      priceComparison={PriceComparisonFromPRID}
                      isApproval={values.Termin1 <= 0 ? false : true}
                      checked={sTermin1 <= 0 ? false : true}
                      showNominal={true}
                    />
                  </div>
                ) : null} */}
                {isJasa && values.Termin1 ? (
                  <div className="w-1/3">
                    <HrdInputGenerator
                      type={"Termin"}
                      value={values}
                      name={"Termin1"}
                      title={"Termin 1 (%)"}
                      onChange={changeHandlerTermin}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={false}
                      errors={errors}
                      disabled={true}
                      priceComparison={PriceComparisonFromPRID}
                      prComparisonID={param.state?.PRComparisonID}
                      isApproval={values.Termin1 <= 0 ? false : true}
                      checked={sTermin1 <= 0 ? false : true}
                      showNominal={true}
                    />
                  </div>
                ) : null}
                {isJasa && values.Termin2 > 0 ? (
                  <div className="w-1/3">
                    <HrdInputGenerator
                      type={"Termin"}
                      value={values}
                      name={"Termin2"}
                      title={"Termin 2 (%)"}
                      onChange={changeHandlerTermin}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={false}
                      errors={errors}
                      disabled={true}
                      priceComparison={PriceComparisonFromPRID}
                      prComparisonID={param.state?.PRComparisonID}
                      isApproval={values.Termin2 <= 0 ? false : true}
                      checked={sTermin2 <= 0 ? false : true}
                      showNominal={true}
                    />
                  </div>
                ) : null}
                {isJasa && values.Termin3 > 0 ? (
                  <div className="w-1/3">
                    <HrdInputGenerator
                      type={"Termin"}
                      value={values}
                      name={"Termin3"}
                      title={"Termin 3 (%)"}
                      onChange={changeHandlerTermin}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={false}
                      errors={errors}
                      disabled={true}
                      priceComparison={PriceComparisonFromPRID}
                      prComparisonID={param.state?.PRComparisonID}
                      isApproval={values.Termin3 <= 0 ? false : true}
                      checked={sTermin3 <= 0 ? false : true}
                      showNominal={true}
                    />
                  </div>
                ) : null}
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"Sifat"}
                    value={values}
                    name={"Sifat"}
                    title={"Sifat Kebutuhan Barang"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"text"}
                    value={values}
                    name={"Requester"}
                    title={"Pemohon"}
                    onChange={changeHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className="w-1/2">
                  <HrdInputGenerator
                    type={"text"}
                    value={values}
                    name={"Remarks"}
                    title={"Keterangan"}
                    onChange={changeHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className="">
                  <div
                    className="w-full px-3"
                    onClick={() => getDataFromURL(values["NamaFile"])}
                  >
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      {values["NamaFile"] && "Ganti "}
                      Data pendukung
                    </label>
                    <label
                      htmlFor={"NamaFile"}
                      className="block w-1/4 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                    >
                      {values["NamaFile"] ? (
                        <span>
                          File Selected -{" "}
                          {values["NamaFile"].name
                            ? values["NamaFile"].name
                            : values["NamaFile"]}
                        </span>
                      ) : (
                        <span>Choose a file...</span>
                      )}
                    </label>
                  </div>
                </div>
                <hr />
                <DynamicTableSimple
                  data={detail}
                  header={header}
                  OnClick={ModalOpener}
                  name={"Purchase Requisition"}
                  barang={barang.data}
                  edit={ModalEdit}
                  delete={ModalDelete}
                />

              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApprovalPurchaseOrderPage;
